<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Overzicht Exportdefinitie'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">
      @if (isAddMode()) {
        Exportdefinitie
      } @else {
        Exportdefinitie - {{ exportDefinitionName() }}
      }
    </h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Exportdefinitie laden...'" />
    </div>
  } @else if (notFound()) {
    <p class="bge-empty">Er zijn geen details voor exportdefinitie gevonden.</p>
  } @else {
    <!-- Details card -->
    <yds-card-editable
      #detailsCard
      title="Details"
      [(editing)]="detailsEditing"
      [nextDisabled]="isSaving() || form.invalid"
      [nextLabel]="isAddMode() ? 'Volgende' : 'Opslaan'"
      (cancel)="onDetailsCancel()"
      (next)="onDetailsNext()"
    >
      @if (detailsEditing()) {
        <form class="gl-form" [formGroup]="form">
          <p class="gl-form__required-hint">
            Velden gemarkeerd met een sterretje
            (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht
          </p>

          @if (isAddMode()) {
            <div class="gl-field">
              <label class="gl-field__label">
                <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Exportdefinitie
              </label>
              <div class="gl-field__control">
                <yds-text-field
                  formControlName="exportDefinitionName"
                  [required]="true"
                  [maxLength]="50"
                  [hasError]="isInvalid(form.get('exportDefinitionName'))"
                  [errorMsg]="'Exportdefinitie is verplicht.'"
                  [placeholder]="'Vul een naam in'"
                />
              </div>
            </div>
          }

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Soort rubriekscheidingsteken
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="itemSeparatorCode"
                [items]="itemSeparatorDropdownOptions()"
                [required]="true"
                [allowClear]="false"
                [placeholder]="'Selecteer soort rubriekscheidingsteken'"
                [hasError]="isInvalid(form.get('itemSeparatorCode'))"
                [errorMsg]="'Soort rubriekscheidingsteken is verplicht.'"
              />
            </div>
          </div>

          @if (showCharacterField().itemSeparatorCharacter) {
            <div class="gl-field">
              <label class="gl-field__label">
                <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Rubriekscheidingsteken
              </label>
              <div class="gl-field__control">
                <yds-text-field
                  formControlName="itemSeparatorCharacter"
                  [required]="true"
                  [maxLength]="50"
                  [hasError]="isInvalid(form.get('itemSeparatorCharacter'))"
                  [errorMsg]="'Rubriekscheidingsteken is verplicht.'"
                  [placeholder]="'Vul een rubriekscheidingsteken in'"
                />
              </div>
            </div>
          }

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Soort regelscheidingsteken
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="lineSeparatorCode"
                [items]="lineSeparatorDropdownOptions()"
                [required]="true"
                [allowClear]="false"
                [placeholder]="'Selecteer soort regelscheidingsteken'"
                [hasError]="isInvalid(form.get('lineSeparatorCode'))"
                [errorMsg]="'Soort regelscheidingsteken is verplicht.'"
              />
            </div>
          </div>

          @if (showCharacterField().lineSeparatorCharacter) {
            <div class="gl-field">
              <label class="gl-field__label">
                <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Regelscheidingsteken
              </label>
              <div class="gl-field__control">
                <yds-text-field
                  formControlName="lineSeparatorCharacter"
                  [required]="true"
                  [maxLength]="50"
                  [hasError]="isInvalid(form.get('lineSeparatorCharacter'))"
                  [errorMsg]="'Regelscheidingsteken is verplicht.'"
                  [placeholder]="'Vul een regelscheidingsteken in'"
                />
              </div>
            </div>
          }

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Soort einde bestand
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="endOfFileCode"
                [items]="endOfFileDropdownOptions()"
                [required]="true"
                [allowClear]="false"
                [placeholder]="'Selecteer soort einde bestand'"
                [hasError]="isInvalid(form.get('endOfFileCode'))"
                [errorMsg]="'Soort einde bestand is verplicht.'"
              />
            </div>
          </div>

          @if (showCharacterField().endOfFileCharacter) {
            <div class="gl-field">
              <label class="gl-field__label">
                <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Teken einde bestand (CHAR(27) is een escape-teken character)
              </label>
              <div class="gl-field__control">
                <yds-text-field
                  formControlName="endOfFileCharacter"
                  [required]="true"
                  [maxLength]="50"
                  [hasError]="isInvalid(form.get('endOfFileCharacter'))"
                  [errorMsg]="'Teken einde bestand is verplicht.'"
                  [placeholder]="'Vul een teken einde bestand in'"
                />
              </div>
            </div>
          }

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Extensie exportbestand
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="exportFileExtensionCode"
                [items]="exportFileExtensionDropdownOptions()"
                [required]="true"
                [allowClear]="false"
                [placeholder]="'Selecteer extensie exportbestand'"
                [hasError]="isInvalid(form.get('exportFileExtensionCode'))"
                [errorMsg]="'Extensie exportbestand is verplicht.'"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Nulregels in exportbestand
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="showZero"
                [items]="showZeroDropdownOptions()"
                [required]="true"
                [allowClear]="false"
                [placeholder]="'Selecteer nulregels in exportbestand'"
                [hasError]="isInvalid(form.get('showZero'))"
                [errorMsg]="'Nulregels in exportbestand is verplicht.'"
              />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Rubrieken aansluitend exporteren</label>
            <div class="gl-field__control">
              <yds-switch formControlName="removeLeadingAndTrailingSpaces" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Boeking met D en C splitsen</label>
            <div class="gl-field__control">
              <yds-switch formControlName="splitBookingOnDebitCredit" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Toepassen rekening omschrijving</label>
            <div class="gl-field__control">
              <yds-switch formControlName="applyAccountDescriptionIndicator" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Toepassen quotes bij n.v.t. waarde</label>
            <div class="gl-field__control">
              <yds-switch formControlName="applyQuotesForNotApplicable" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Automatisch journaliseren</label>
            <div class="gl-field__control">
              <yds-switch formControlName="automaticJournaling" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Begindatum
            </label>
            <div class="gl-field__control">
              <yds-date-picker
                formControlName="startDate"
                [required]="true"
                [locale]="translate.getCurrentLang()"
                [placeholder]="'dd-mm-jjjj'"
                [allowTodayAction]="false"
                [errorMessage]="isInvalid(form.get('startDate')) ? 'Begindatum is verplicht.' : ''"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">Einddatum</label>
            <div class="gl-field__control">
              <yds-date-picker
                formControlName="endDate"
                [locale]="translate.getCurrentLang()"
                [placeholderKey]="null"
                [placeholder]="''"
                [allowTodayAction]="false"
                [errorMessage]="
                  form.hasError('startBeforeEnd') && form.get('endDate')?.touched
                    ? 'Begindatum moet voor einddatum liggen'
                    : ''
                "
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">Memo</label>
            <div class="gl-field__control">
              <yds-text-area
                formControlName="memoValue"
                [placeholder]="'Type hier...'"
                [maxLength]="500"
                [showCounter]="true"
              />
            </div>
          </div>
        </form>
      } @else {
        <div class="gl-detail">
          <div class="gl-detail__row">
            <span class="gl-detail__label">Soort rubriekscheidingsteken</span>
            <span class="gl-detail__value">{{ selectionLabel(itemSeparatorOptions(), detail()?.itemSeparatorCode) }}</span>
          </div>
          @if (isOtherCode(detail()?.itemSeparatorCode)) {
            <div class="gl-detail__row">
              <span class="gl-detail__label">Rubriekscheidingsteken</span>
              <span class="gl-detail__value">{{ detail()?.itemSeparatorCharacter || 'N.v.t.' }}</span>
            </div>
          }
          <div class="gl-detail__row">
            <span class="gl-detail__label">Soort regelscheidingsteken</span>
            <span class="gl-detail__value">{{ selectionLabel(lineSeparatorOptions(), detail()?.lineSeparatorCode) }}</span>
          </div>
          @if (isOtherCode(detail()?.lineSeparatorCode)) {
            <div class="gl-detail__row">
              <span class="gl-detail__label">Regelscheidingsteken</span>
              <span class="gl-detail__value">{{ detail()?.lineSeparatorCharacter || 'N.v.t.' }}</span>
            </div>
          }
          <div class="gl-detail__row">
            <span class="gl-detail__label">Soort einde bestand</span>
            <span class="gl-detail__value">{{ selectionLabel(endOfFileOptions(), detail()?.endOfFileCode) }}</span>
          </div>
          @if (isOtherCode(detail()?.endOfFileCode)) {
            <div class="gl-detail__row">
              <span class="gl-detail__label">Teken einde bestand</span>
              <span class="gl-detail__value">{{ detail()?.endOfFileCharacter || 'N.v.t.' }}</span>
            </div>
          }
          <div class="gl-detail__row">
            <span class="gl-detail__label">Extensie exportbestand</span>
            <span class="gl-detail__value">{{ selectionLabel(exportFileExtensionOptions(), detail()?.exportFileExtensionCode) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Nulregels in exportbestand</span>
            <span class="gl-detail__value">{{ selectionLabel(showZeroOptions(), detail()?.showZero) }}</span>
          </div>

          @for (setting of booleanSettings; track setting.label) {
            <div class="gl-detail__row gl-detail__row--inline">
              <span class="gl-detail__label">{{ setting.label }}</span>
              <span class="gl-detail__value gl-detail__value--setting">
                @if (setting.value()) {
                  <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                  <span>Aan</span>
                } @else {
                  <span>Uit</span>
                }
              </span>
            </div>
          }

          <div class="gl-detail__row">
            <span class="gl-detail__label">Begindatum</span>
            <span class="gl-detail__value">{{ startDateDisplay() }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Einddatum</span>
            <span class="gl-detail__value">{{ endDateDisplay() }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Memo</span>
            <span class="gl-detail__value gl-detail__value--memo">{{ memoDisplay() }}</span>
          </div>
        </div>
      }
    </yds-card-editable>

    @if (!isAddMode()) {
      <!-- Verdichtingscriteria card -->
      <yds-card-editable
        title="Verdichtingscriteria"
        [(editing)]="criteriaEditing"
        nextLabel="Opslaan"
        [nextDisabled]="isSavingCriteria()"
        (cancel)="onCriteriaCancel()"
        (next)="onCriteriaSave()"
      >
        @if (criteriaEditing()) {
          <div class="gl-form">
            @for (slot of criterionSlots; track slot.number) {
              <div class="gl-field gl-field--inline">
                <label class="gl-field__label">{{ slot.label }}</label>
                <div class="gl-field__control">
                  <yds-switch
                    [value]="isCriterionSelected(slot.number)"
                    (valueChange)="toggleCriterion(slot.number, $event)"
                  />
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="gl-detail">
            @for (slot of criterionSlots; track slot.number) {
              <div class="gl-detail__row gl-detail__row--inline">
                <span class="gl-detail__label">{{ slot.label }}</span>
                <span class="gl-detail__value gl-detail__value--setting">
                  @if (isCriterionSelected(slot.number)) {
                    <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                    <span>Aan</span>
                  } @else {
                    <span>Uit</span>
                  }
                </span>
              </div>
            }
          </div>
        }
      </yds-card-editable>

      <!-- Exportregel card -->
      <yds-card>
        <div header class="edx-card-header">
          <h2 class="edx-card-header__title">Exportregel</h2>
        </div>

        @for (section of ruleSections(); track section.code) {
          <div class="edx-rule-section">
            <h3 class="edx-rule-section__title">{{ section.label }}</h3>

            @if (section.rule; as rule) {
              <div class="gl-detail">
                <div class="gl-detail__row">
                  <span class="gl-detail__label">Regelomschrijving</span>
                  <span class="gl-detail__value">{{ rule.exportRuleName }}</span>
                </div>
                <div class="gl-detail__row">
                  <span class="gl-detail__label">Soort regel</span>
                  <span class="gl-detail__value">{{ section.label }}</span>
                </div>
                <div class="gl-detail__row">
                  <span class="gl-detail__label">Niveau kopregel</span>
                  <span class="gl-detail__value">{{ headerLevelLabel(rule.headerLevel) }}</span>
                </div>
                <div class="gl-detail__row gl-detail__row--inline">
                  <span class="gl-detail__label">Toepassen rubriekscheidingsteken</span>
                  <span class="gl-detail__value gl-detail__value--setting">
                    @if (rule.applyItemSeparator) {
                      <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                      <span>Aan</span>
                    } @else {
                      <span>Uit</span>
                    }
                  </span>
                </div>
                <div class="gl-detail__row gl-detail__row--inline">
                  <span class="gl-detail__label">Toepassen regelscheidingsteken</span>
                  <span class="gl-detail__value gl-detail__value--setting">
                    @if (rule.applyLineSeparator) {
                      <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                      <span>Aan</span>
                    } @else {
                      <span>Uit</span>
                    }
                  </span>
                </div>
              </div>

              <div class="edx-rule-section__actions">
                <yds-button variant="default" size="sm" (click)="openEditRule(rule)">Wijzigen</yds-button>
                <yds-button variant="destructive" size="sm" (click)="removeRule(rule)">Verwijderen</yds-button>
              </div>
            } @else {
              <p class="bge-empty">Er is nog geen {{ section.label.toLowerCase() }}.</p>
              <button type="button" class="gl-grid__add-link" (click)="openAddRule(section.code)">
                + Voeg {{ section.label.toLowerCase() }} toe
              </button>
            }
          </div>
        }
      </yds-card>
    }
  }

  <app-exportrule-dialog
    [(open)]="dialogOpen"
    [exportDefinitionId]="exportDefinitionId() ?? ''"
    [kindOptions]="kindOptions()"
    [headerLevelOptions]="headerLevelOptions()"
    [existingKinds]="existingKinds()"
    [editRule]="dialogEditRule()"
    [presetKind]="dialogPresetKind()"
    (saved)="onRuleSaved()"
  />
</div>
